import cn from 'classnames';
import type React from 'react';
import { useCallback, useLayoutEffect, useState } from 'react';
import Modal from 'react-modal';
import { useAppDispatch } from '@shared/hooks';
import { MediumHeader } from '@shared/ui';
import { useResetPasswordModal } from '@src/modules/Authentication/frames/reset-password-form/model.ts';
import { ResetPassword } from '@src/modules/Authentication/frames/reset-password-form/ui.tsx';
import { closeAuthModal } from 'library/redux/modal';
import { Login, Register, Restore } from './frames';
import { useAuth } from './AuthContext';
import * as st from './styles.module.scss';

const Authentication: React.FC = () => {
  const authContext = useAuth();
  const [showRestore, setShowRestore] = useState(false);
  const dispatch = useAppDispatch();

  const { openedTabInfo, resetOpenedTabInfo } = useResetPasswordModal();

  const openTab = useCallback(
    (tab: string) => {
      authContext.dispatch({ type: 'tab', payload: tab });
      setShowRestore(false);
    },
    [authContext, setShowRestore]
  );

  const openRestore = () => {
    authContext.dispatch({ type: 'tab', payload: false });
    authContext.dispatch({ type: 'head', payload: 'Восстановление пароля' });
    setShowRestore(true);
  };

  const openRegister = () => {
    authContext.dispatch({ type: 'head', payload: '' });
    openTab('register');
  };

  useLayoutEffect(() => {
    if (openedTabInfo) {
      openTab('resetPassword');
      authContext.dispatch({ type: 'head', payload: openedTabInfo.head });
      resetOpenedTabInfo();
    }
  }, [openedTabInfo, openTab, authContext, resetOpenedTabInfo]);

  return (
    <Modal isOpen={true} ariaHideApp={false} className={cn(st.modal)} overlayClassName={st.overlay}>
      <MediumHeader
        onClose={() => dispatch(closeAuthModal())}
        title={
          authContext.state.head ? (
            <div className={st.head}>{authContext.state.head}</div>
          ) : (
            <section className={st.tabs}>
              <button
                className={cn(authContext.state.tab === 'login' && st.tabs__active)}
                onClick={() => openTab('login')}
              >
                Вход
              </button>
              <button
                className={cn(authContext.state.tab === 'register' && st.tabs__active)}
                onClick={() => openTab('register')}
              >
                Регистрация
              </button>
            </section>
          )
        }
      />
      <div className={st.wrapper}>
        {authContext.state.tab === 'resetPassword' && <ResetPassword openRestore={openRestore} />}
        {authContext.state.tab === 'login' && <Login openRestore={openRestore} />}
        {authContext.state.tab === 'register' && <Register openRestore={openRestore} />}
        {showRestore && <Restore openLogin={() => openTab('login')} openRegister={openRegister} />}
      </div>
      <div className={st.fake}>a</div>
    </Modal>
  );
};

export default Authentication;
